// A page that fails to download one of its code chunks (flaky phone network, or
// a tab left open across a deploy) crashes into the error boundary. A plain
// reload almost always fixes it, so the boundaries reload once by themselves
// instead of showing the crash screen. The timestamp in sessionStorage stops a
// reload loop: a second chunk failure within RELOAD_WINDOW_MS shows the normal
// error screen and is reported. (Issue 41a65fb9, iPhone on /login, 2026-10-25.)

const STORAGE_KEY = 'jm_chunk_reload_at'
const RELOAD_WINDOW_MS = 60_000

const CHUNK_ERROR_RE =
  /Loading chunk|Failed to load chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const { name, message } = error as { name?: unknown; message?: unknown }

  return name === 'ChunkLoadError' || (typeof message === 'string' && CHUNK_ERROR_RE.test(message))
}

/** True when this error should be fixed by one automatic reload (no reload yet in the window). */
export function shouldAutoReload(error: unknown): boolean {
  if (typeof window === 'undefined' || !isChunkLoadError(error)) return false

  try {
    const last = Number(window.sessionStorage.getItem(STORAGE_KEY) || 0)

    return Date.now() - last > RELOAD_WINDOW_MS
  } catch {
    // No storage means no loop guard, so never auto-reload.
    return false
  }
}

/** Records the attempt and reloads. Call only after shouldAutoReload() returned true. */
export function reloadForChunkError(): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
  } catch {
    return
  }

  window.location.reload()
}
